// Single source of truth for plan billing amounts (in cents).
// Used both to render the pricing page and to build the SoftwareApplication
// structured data on /pricing, so the two never drift apart.
module.exports = exports = {
  FREE: [
    { amount: 0, interval: 'year', currency: 'usd' },
    { amount: 0, interval: 'year', currency: 'eur' }
  ],
  MAKER: [
    {
      amount: 18000,
      interval: 'year',
      currency: 'usd'
    },
    {
      amount: 18000,
      interval: 'year',
      currency: 'eur'
    },
    {
      amount: 1800,
      interval: 'month',
      currency: 'usd'
    },
    {
      amount: 1800,
      interval: 'month',
      currency: 'eur'
    }
  ],
  PRO: [
    {
      amount: 60000,
      interval: 'year',
      currency: 'usd'
    },
    {
      amount: 6000,
      interval: 'month',
      currency: 'usd'
    },
    {
      amount: 54000,
      interval: 'year',
      currency: 'eur'
    },
    {
      amount: 5500,
      interval: 'month',
      currency: 'eur'
    }
  ],
  TEAM: [
    {
      amount: 210000,
      interval: 'year',
      currency: 'usd'
    },
    {
      amount: 22500,
      interval: 'month',
      currency: 'usd'
    },
    {
      amount: 180000,
      interval: 'year',
      currency: 'eur'
    },
    {
      amount: 20000,
      interval: 'month',
      currency: 'eur'
    }
  ],
  ENTERPRISE: [
    { amount: 330000, interval: 'year', currency: 'eur' },
    { amount: 420000, interval: 'year', currency: 'usd' }
  ]
};
